module.exports = __webpack_public_path__ + "c666ba603e0170cb3f876f6dfed123ea.svg";